import React from "react"
import Menu from "../Menu/Menu"
import { HeaderTypes, ItemsProps } from "../Header"
import { roles } from "../../../TopBar/Roles/RolesTypes"

const RolesMenu = ({ showOptions, handleToggleOptions }: ItemsProps) => {
  return (
    <Menu
      title={HeaderTypes.ROLES}
      items={roles}
      showOptions={showOptions}
      handleToggleOptions={handleToggleOptions}
    />
  )
}

export default RolesMenu
